<script setup lang="ts">
import LoginForm from '@/components/login/LoginForm.vue'
</script>

<template>
  <div class="relative flex min-h-svh items-center justify-center bg-muted p-4">
    <div aria-hidden />
    <div class="absolute w-full h-full">
      <img
        class="h-full w-full absolute object-cover object-top"
        src="/background_pattern_1.svg"
        alt="UNSSC Background"
      />
    </div>
    <div class="h-full z-10">
      <LoginForm />
    </div>
  </div>
</template>
